import { computed, Ref } from 'vue'
import { format } from 'date-fns'
import { ShiftDetails, StationFormSchedule } from '@/Network/Types/Responses/StationResponses'

type SummaryMode = 'management' | 'remove'
type FormatMode = 'management' | 'remove'

export function useSummaryText(
  doctorName: Ref<string | undefined>,
  shiftCount: Ref<number>,
  mode: SummaryMode
): string {
  if (shiftCount.value === 0) {
    return 'Nenhum plantão encontrado com os filtros selecionados.'
  }

  const effectiveDoctorName = doctorName.value || 'o médico selecionado'
  const plural = shiftCount.value > 1 ? 'plantões' : 'plantão'

  if (mode === 'management') {
    return `Você está alocando ${effectiveDoctorName} para ${shiftCount.value} ${plural}. Deseja continuar?`
  }

  return `Você está prestes a remover o médico(a) ${effectiveDoctorName} para ${shiftCount.value} ${plural}. Deseja continuar?`
}

export function useFormattedShifts(shifts: Ref<StationFormSchedule[]>, mode: FormatMode) {
  return computed(() => {
    if (!shifts.value) return []

    return shifts.value.map((station) => {
      const baseShift = {
        id: `#${station.stationId}`,
        startDate: format(new Date(station.startDate), 'dd/MM/yyyy'),
        startTime: format(new Date(station.startTime), 'HH:mm'),
        endDate: format(new Date(station.endDate), 'dd/MM/yyyy'),
        endTime: format(new Date(station.endTime), 'HH:mm'),
        value: station.value ? `R$${station.value.toFixed(2).replace('.', ',')}` : 'indisponível'
      }

      if (mode === 'remove') {
        return {
          ...baseShift,
          position: station.position || 'N/A'
        }
      }

      return {
        ...baseShift,
        availability: station.isOpen ? 'Aberta' : 'Com médico'
      }
    })
  })
}

export function useExpandedTable(
  isMainModalVisible: Ref<boolean>,
  isExpandedModalVisible: Ref<boolean>
) {
  const handleExpandTable = () => {
    isMainModalVisible.value = false
    isExpandedModalVisible.value = true
  }

  const handleCloseExpandedTable = () => {
    isExpandedModalVisible.value = false
    isMainModalVisible.value = true
  }

  return {
    handleExpandTable,
    handleCloseExpandedTable
  }
}

export function useInitialPage(stationDetails: Ref<ShiftDetails | null>) {
  return computed(() => {
    const today = new Date()
    const endDate = stationDetails.value?.schedule.endDate
      ? new Date(stationDetails.value.schedule.endDate)
      : null

    if (endDate && endDate < today) {
      return { year: endDate.getFullYear(), month: endDate.getMonth() + 1 }
    }
    return { year: today.getFullYear(), month: today.getMonth() + 1 }
  })
}
